import { checkObjectsDeepEqual, checkObjectsReferentiallyEqualForKeys, checkObjectsReferentiallyEqualPerKey, checkValuesReferentiallyEqual, } from '@hawkins/helpers';
/**
 * Two sets of options are considered "equal" if, for every option, all of the keys'
 * values for the option are referentially equal to the keys' values for the option
 * in the same position of the other set.
 */
export function checkDropdownOptionsReferentiallyEqualPerKey(opt1, opt2) {
    return checkObjectsReferentiallyEqualPerKey(opt1, opt2);
}
/**
 * Two sets of options are considered "equal" if the sets themselves are referentially equal.
 */
export function checkDropdownOptionsReferentiallyEqual(opt1, opt2) {
    return checkValuesReferentiallyEqual(opt1, opt2);
}
/**
 * Two sets of options are considered "equal" when their shapes are deeply equal, regardless of
 * any referential equality.
 */
export function checkDropdownOptionsDeepEqual(opt1, opt2) {
    return checkObjectsDeepEqual(opt1, opt2);
}
/**
 * Two sets of rawValues are considered "equal" when their shapes are deeply equal, regardless
 * of any referential equality.
 */
export var checkRawValuesDeepEqual = checkObjectsDeepEqual;
/**
 * Two rawValues are considered "equal" if they are referentially equal.
 */
export var checkRawValuesReferentiallyEqual = checkValuesReferentiallyEqual;
/**
 * Two sets of object-based rawValues are considered "equal" if, for every rawValue, all of
 * the keys' values for the rawValue are referentially equal to the keys' values for the
 * rawValue in the same position of the other set.
 */
export var checkRawValuesReferentiallyEqualPerKey = checkObjectsReferentiallyEqualPerKey;
/**
 * Two sets of objects are considered "equal" if, for every object, all of the keys passed
 * in match referentially to the corresponding object in the other set
 */
export var checkOptionsReferentiallyEqualForKeys = checkObjectsReferentiallyEqualForKeys;
